export const WorkData = [
  {
    id: 1,
    name: "Resturant Website",
    demo: "resturant112.herokuapp.com/",
    github: "https://github.com/aman34503/Resturant-Website",
    status: "Maintained ",
    description: "The restaurant is a creative and responsive restaurant website theme in Hugo environment. It is a very well decorated theme which will make your website building easier.",
    techStack: ["React", "MaterialUI", "Bootstrap", "fetch-api"]
  },
  {
    id: 2,
    name: "Let's Talk - Web App",
    demo: "http://ecosocial.ga",
    github: "https://github.com/aman34503/Lets-Talk/tree/master",
    status: "Maintained ",
    description: "LetsTalk an application for those who are alone, they don't have any friends or if they want to talk someone they can reduce their anxiety with some techniques.",
    techStack: ["React", "react-router", "Firestore-Database", "Socket.io", "Bootstrap", "MaterialUI"]
  },
  {
    id: 3,
    name: "Go-Airbnb",
    demo: "radiant-sea-41759.herokuapp.com/home",
    github: "https://github.com/aman34503/Go-Airbnb",
    status: "Maintained ",
    description: "Nearby Places search, Hotel Booking Application.",
    techStack: ["JavaScript", "React", "react-router", "Framer motion", "MaterialUI"]
  },
  {
    id: 4,
    name: "Potencymate - ChromeExtension",
    demo: "https://github.com/aman34503/Potencymate---ChromeExtension",
    github: "https://github.com/aman34503/Potencymate---ChromeExtension",
    status: "Maintained ",
    description: "Potencymate is a Chrome extension based off of the Pomodoro Technique, where you work in hyper-focused sprints of 25 minutes followed by a 5 minute rest interval.",
    techStack: ["HTML", "OAuth", "JavaScript"]
  },
  {
    id: 5,
    name: "Webflix - Movie Website",
    demo: "https://aman34503.github.io/WebFlix/",
    github: "https://github.com/aman34503/WebFlix",
    status: "Maintained ",
    description: "Web app which generates new Movies.",
    techStack: ["HTML", "CSS", "Bootstrap"]
  }
];
